import {createElement, PropTypes} from 'rlink-react';
import {mergeStaticOptions} from 'rlink-utils/object';

import InputBase from './InputBase';

export default class TextContentInput extends InputBase {
  constructor (props, context) {
    super(props, context);
    this.attributes = {};
  }

  get inputTag () {
    return 'input';
  }

  get pattern () {
    return this.fromPropsOrContext('pattern');
  }

  get attributes () {
    return this._attributes;
  }

  set attributes (attributes) {
    this._attributes = attributes;
  }

  normalizeValue (value) {
    return value ? value.trim() : '';
  }

  hasValue (value) {
    return this.normalizeValue(value).length > 0;
  }

  addValidationProblems (ev) {
    super.addValidationProblems(ev);

    if (this.maxLength
        && (ev.value.length > this.maxLength)) {
      this.addProblem(ev, 'TOO_LONG');
    }
    if (this.minLength
        && (ev.value.length < this.minLength)) {
      this.addProblem(ev, 'TOO_SHORT');
    }

    if (this.pattern && !this.pattern.test(this.normalizeValue(this.value))) {
      this.addProblem(ev, 'INVALID_CHARACTERS');
    }
  }

  renderInput () {
    /* eslint-disable react/prop-types */
    return <this.inputTag type={this.inputType}
      id={this.labelId}
      ref={input => {
        this.inputRef = input;
      }}
      disabled={this.disabled}
      autoFocus={this.autoFocus}
      autoComplete={this.autoComplete}
      name={this.name}
      onFocus={ev => this.handleFocus(ev)}
      onBlur={ev => this.handleBlur(ev)}
      onChange={ev => this.handleChange(ev)}
      value={this.value}
      {...this.attributes} />;
  }
  /* eslint-enable react/prop-types */
}


mergeStaticOptions(TextContentInput, {
  propTypes: {
    value: PropTypes.string,
    committedValue: PropTypes.string,
    minLength: PropTypes.number,
    maxLength: PropTypes.number,
    placeholder: PropTypes.string,
    pattern: PropTypes.instanceOf(RegExp),
  },
});



// WEBPACK FOOTER //
// ./lib/rlink-forms/inputs/TextContentInput.jsx